import React, { useState, useEffect, useGlobal } from 'reactn';

import history from "../navigator/history";

/** External libraries **/
import { Ability } from "@casl/ability";
import Storage from 'react-native-storage';

/** Providers **/
import User from "../providers/UserProvider";

import ApmService from '../services/Apm';
import Utils from '../lib/Utils';

/** Initialize storage */
const storage = new Storage({
  size: 1000,
  storageBackend: window.localStorage
});

const useAuth = () => {
  const [user, setUser] = useGlobal("user");
  const [token, setToken] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    loadUser();
  }, [])

  const loadUser = async () => {
    let apiToken    = await getToken();
    let queryParams = Utils.getQueryStringParams(history.location.search)

    if (apiToken && !apiToken.error) {
      setToken(apiToken);

      let result = await User.rescueUser({ api_token: apiToken });

      if(!result.error) {
        setUser({ ...result, ability: new Ability(result.rules) })
      } else {
        // Tipically user timed out!
        setToken(null)
      }

    // If api token is not present, then check if we have jwt token on queryParams
    } else if (queryParams && queryParams.jwt) {

      let result = await User.signInJwt({ raw_token: queryParams.jwt });

      if (!result.error) {
        await storage.save({ key: 'token', data: result.api_token })
        setToken(result.api_token);
        setUser({ ...result, ability: new Ability(result.rules), jwt_logged: true })
      } else {
        setError(result.error)
      }
    }

    setLoading(false)
  }

  const signOut = async () => {
    let apiToken = await getToken();

    if (!apiToken.error) {
      let result = await User.signOut({ apiToken })

      await removeToken();
      setUser(null)
      setToken(null)
    }
  }

  const getToken = async () => {
    try {
      return await storage.load({key: 'token'})
    }
    catch (error) {
      ApmService.noticeError({message: 'ERROR TO GET TOKEN'}, error)
      return { error }
    }
  }

  const removeToken = async () => {
    try {
      await storage.remove({ key: 'token' });
      return {}
    }
    catch (error) {
      ApmService.noticeError({message: 'ERROR TO REMOVE TOKEN'}, error)
      return { error }
    }
  }

  // Return loading: true while executing loadUser method.
  if (loading) {
    return [ user, signOut, true, error ]
  }

  // Return loading: false if we found a user of dont have a token.
  if (user || !token) {
    return [ user, signOut, false, error ]
  }

  // Return loading: true if we dont have a user and have a token.
  return [ user, signOut, true, error ]
}

export { useAuth }
